import { I18n } from '@calendly/i18n'

import { ButtonBlock, Container, PrimaryText, SecondaryText } from './empty_state_styles'
import { NewWorkflowButton } from './new_workflow_button'

export const UserDisabledWorkflows = () => (
  <Container>
    <PrimaryText>
      {I18n.t('publisher.workflows.disabled_state.for_user')}
    </PrimaryText>
  </Container>
)

export const EmptyUserWorkflows = ({ owner }) => (
  <Container>
    <PrimaryText>
      {I18n.t('publisher.workflows.empty_state.for_user.line1')}
    </PrimaryText>
    <SecondaryText>
      {I18n.t('publisher.workflows.empty_state.for_user.line2')}
    </SecondaryText>
    <ButtonBlock>
      <NewWorkflowButton owner={owner} />
    </ButtonBlock>
  </Container>
)
